import * as types from './types';

export const requestLogin = (email, password, remember_login) => ({
  type: types.REQUEST_LOGIN,
  payload: {
    email: email || null,
    password: password || null,
    remember_login: remember_login || false,
  }
});

export const requestVerify = (password, password_confirm, id, hash, signature, expires) => ({
  type: types.REQUEST_VERIFY,
  payload: {
    password: password || null,
    password_confirm: password_confirm || null,
    id: id || null,
    hash: hash || null,
    signature: signature || null,
    expires: expires || false,
  }
});

export const tokenDetails = (access_token, expires_at, refresh_token, expires_in) => ({
  type: types.TOKEN_DETAILS,
  payload: {
    access_token: access_token || null,
    expires_at: expires_at || null,
    refresh_token: refresh_token || null,
    expires_in: expires_in || null,
  }
});

export const userInfoLoading = () => ({
  type: types.USER_INFO_LOADING,
});

export const userInfo = (id, first_name, last_name, email, groups, acl, passkey_auth) => ({
  type: types.USER_INFO,
  payload: {
    id: id || null,
    first_name: first_name || null,
    last_name: last_name || null,
    email: email || null,
    groups: groups || [],
    acl: acl || [],
    passkey_auth: passkey_auth || false,
  }
});

export const userDetails = (stopRedirect) => ({
  type: types.USER_DETAILS,
  payload: {
    stopRedirect: stopRedirect || false
  }
});

export const requestLogOut = (isUnauthorized) => ({
  type: types.USER_LOGOUT,
  payload: {
    isUnauthorized: isUnauthorized || false
  }
});

export const requestForgot = (email) => ({
  type: types.REQUEST_FORGOT,
  payload: {
    email: email || null
  }
});

export const requestNewPassword = (password, password_confirmation, token) => ({
  type: types.REQUEST_NEW_PASSWORD_FORGOT,
  payload: {
    token: token || null,
    password: password || null,
    password_confirmation: password_confirmation || null
  }
});

export const requestVerification = (userId, verificationHash, expires, signature) => ({
  type: types.REQUEST_VERIFICATION_USER,
  payload: {
    userId: userId || null,
    verificationHash: verificationHash || null,
    expires: expires || null,
    signature: signature || null,
  }
});

export const requestNewVerificationEmail = (email) => ({
  type: types.REQUEST_NEW_VERIFICATION_USER,
  payload: {
    email: email || null,
  }
});

export const verifyEmailValidFlag = (verificationSucceed) => ({
  type: types.EMAIL_VERIFICATION_SUCCESS,
  payload: {
    verificationSucceed: verificationSucceed || false,
  }
});

export const verifyEmailResendFlag = (flag) => ({
  type: types.EMAIL_VERIFICATION_RESEND,
  payload: {
    emailResend: flag || false,
  }
});

export const updateProfile = (first_name, last_name, email) => ({
  type: types.UPDATE_PROFILE,
  payload: {
    first_name: first_name || null,
    last_name: last_name || null,
    email: email || null,
  }
});

export const changePassword = (password, new_password, new_password_confirmation) => ({
  type: types.UPDATE_PROFILE,
  payload: {
    old_password: password || null,
    new_password: new_password || null,
    new_password_confirmation: new_password_confirmation || null,
  }
});

export const tablesSearches = (searches) => ({
  type: types.TABLES_SEARCHES,
  payload: {
    tablesSearches: searches || null,
  }
});

export const updateSecurityOptions = (passkey_auth) => ({
  type: types.UPDATE_PROFILE,
  payload: {
    passkey_auth: passkey_auth || false,
  }
});

export const requestLoginPasskey = () => ({
  type: types.REQUEST_LOGIN_PASSKEY,
  payload: {}
});

export const pushNotificationsSubscribe = () => ({
  type: types.PUSH_NOTIFICATIONS_SUBSCRIBE,
})

export const pushNotificationsUnsubscribe = () => ({
  type: types.PUSH_NOTIFICATIONS_UNSUBSCRIBE,
})